import React from "react";
import "./Header.css";

const Header = () => {
  return (
    <header className="headerapp">
      <h2>App Tareas</h2>
      <a href="https://lburbano.site">Leandro Burbano</a>
    </header>
  );
};

export default Header;
